export default function evnet(id) {
  return [{
    title: '事件',
    labelWidth: '100px',
    items: [{
      type: 'table',
      name: 'events',
      span: 12,
      columns: [{
        name: 'name',
        label: '事件名',
        inputType: 'uiEvent',
        cid: id,
      }, {
        name: 'to',
        label: '联动组件',
        inputType: 'uiSelect',
      }, {
        name: 'method',
        label: '联动组件动作名',
        inputType: 'uiMethodselect',
      }],
    }],
  }];
}
